module.exports = __webpack_public_path__ + "static/media/background.088c2707.mp4";